import { Vector2 } from "three";
import { HSLColor } from "../../../colors/HSLColor";
import { DOMHitTest } from "../../../dom-tools/DOMHitTest";
import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementType } from "../../../dom-tools/ElementType";
import { Events, OnClick, OnDrag } from "../../../dom-tools/EventListeners";
import { DragData } from "../../../dom-ui/basics/DragData";
import { CanvasDrawer } from "../../../dom/CanvasDrawer";
import { WaveForm } from "./WaveForm";
import { WaveformChannelType, WaveformGenerationOptions } from "./WaveFormGenerationOptions";
import { WaveFormRenderer } from "./WaveFormRenderer";

export class WaveFormTestElement extends Element
{
  _hasWaveFrom:boolean = false;
  _renderer:WaveFormRenderer;
}

export class WaveFormTester
{
  static readonly type = new ElementType( "wave-form-tester" );
  static readonly source = new ElementAttribute( "source" );

  static applyOnDocument()
  {
    WaveFormTester.type.forAllInDoc( e => WaveFormTester.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {
    console.log( "wave-form-tester:", e );

    let wfe = e as WaveFormTestElement;
    wfe._hasWaveFrom = false;

    let canvas = ElementType.canvas.create();
    canvas.width = 1920;
    canvas.height = 256;

    let renderer = new CanvasDrawer( canvas );
    renderer.fillBackground( new HSLColor( 0, 0, 10 ) );

    e.appendChild( canvas );

    console.log( "wave-form-tester: added canvas", e );

    let source = WaveFormTester.source.from( e );

    console.log( "wave-form-tester: source", source );

    OnClick.add( canvas, 
      async ( ev ) =>
      {
        if ( wfe._hasWaveFrom )
        {
          return;
        }
        
        wfe._hasWaveFrom = true;
        console.log( "wave-form-tester: creating context" );

        let audioContext = new AudioContext();

        let options = new WaveformGenerationOptions();
        options.highestZoomLevel = 1;
        options.lowestZoomLevel  = 20;
        options.type = WaveformChannelType.EXTREMES;

        console.log( "wave-form-tester: loading wave data" );
        let waveforms = await WaveForm.loadFromURL( source, audioContext, options ); 

        console.log( "wave-form-tester: creating renderer" );
        let renderer = new WaveFormRenderer( canvas, waveforms[ 0 ] );

        renderer.renderWave();
        console.log( "wave-form-tester: renderer wave" );

        wfe._renderer = renderer;
      }
    );
    
    let startData:DragData<number>;
    let lastMoved:DragData<number>;
    let dragging = false;
    let changingLevels = false;

    OnDrag.add( canvas,
      ( e )=>
      {
        if ( ! wfe._renderer )
        {
          return;
        }

        let mouseEvent = Events.toMouseEvent( e );
        
        
        if ( ! mouseEvent )
        {
          return;
        }

        
        let data = DragData.create( e, null );

        if ( Events.isStart( e ) )
        {
          changingLevels = mouseEvent.button === Events.MouseButtonLeft && ! ( e.ctrlKey || e.shiftKey ) ;

          if ( ! changingLevels )
          {
            return;
          }

          startData = data;

          let center = DOMHitTest.getNormalizedPosition( startData.position.clone(), canvas );
          startData.value = wfe._renderer.getDataPositionAtNormalizedX( center.x );
          lastMoved = startData;         
          
        }

        if ( ! changingLevels )
        {
          return;
        }

        if ( Events.isMove( e ) )
        {
          let movement = data.position.clone().sub( lastMoved.position );
          
          if ( e.ctrlKey )
          {
            movement.y = 0;
          }

          if ( e.shiftKey )
          {
            movement.x = 0;
          }

          wfe._renderer.changeSamplingLevel( movement, startData.value, new Vector2( canvas.width, canvas.height ), 70 );
        }

        lastMoved = data;

        

      } 
    );


    OnDrag.add( canvas,
      ( e )=>
      {
        if ( ! wfe._renderer )
        {
          return;
        }

        let mouseEvent = Events.toMouseEvent( e );
        
        
        if ( ! mouseEvent )
        {
          return;
        }

        
        let data = DragData.create( e, null );

        if ( Events.isStart( e ) )
        {
          dragging = mouseEvent.button === Events.MouseButtonMiddle || 
                    ( mouseEvent.button === Events.MouseButtonLeft && ( e.ctrlKey || e.shiftKey ) );

          if ( ! dragging )
          {
            return;
          }

          startData = data;

          let center = DOMHitTest.getNormalizedPosition( startData.position.clone(), canvas );
          startData.value = wfe._renderer.getDataPositionAtNormalizedX( center.x );
          lastMoved = startData;         
          
        }

        if ( ! dragging )
        {
          return;
        }

        if ( Events.isMove( e ) )
        {
          let movement = data.position.clone().sub( lastMoved.position );
          
          if ( e.ctrlKey )
          {
            movement.y = 0;
          }

          if ( e.shiftKey )
          {
            movement.x = 0;
          }

          wfe._renderer.changeView( movement, startData.value, new Vector2( canvas.width, canvas.height ), 70 );
        }

        lastMoved = data;

        

      } 
    );
  } 
}